<header class="page-head" data-testid="campaigns-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-bolt"></i></span>
    <div>
      <h1 class="page-head__title">Automações</h1>
      <p class="page-head__subtitle">Sequências de SMS, WhatsApp, voz e webhook disparadas quando o lead entra numa lista.</p>
    </div>
  </div>
  <div class="page-head__actions">
    <a [routerLink]="['/campaigns/new']" class="sf-btn sf-btn--primary" data-testid="btn-new-campaign">
      <i class="fa fa-plus-circle"></i> Nova automação
    </a>
  </div>
</header>

<div class="filter-bar">
  <div class="search-wrap grow">
    <i class="fa fa-search"></i>
    <input
      type="text"
      name="name"
      class="form-control"
      placeholder="Pesquisar automação pelo nome"
      [(ngModel)]="name"
      (keyup)="filterKeyPress($event)"
      data-testid="input-search-campaign"
    />
    <button type="button" class="search-go" aria-label="Pesquisar" (click)="pageChanged(page)" data-testid="btn-search-campaign">
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
  <div class="seg" role="tablist" aria-label="Status" data-testid="filter-status">
    <button
      type="button"
      role="tab"
      *ngFor="let s of statusSegments"
      [class.on]="isStatus(s.value)"
      [attr.aria-selected]="isStatus(s.value)"
      (click)="filterByStatus(s.value)"
      [attr.data-testid]="'status-' + s.key"
    >
      {{ s.label }}
    </button>
  </div>
</div>

<div class="filter-bar filter-bar--selects">
  <div class="field">
    <label for="integration_id">Integração</label>
    <select name="integration_id" id="integration_id" class="form-select"
      [(ngModel)]="integrationId"
      (change)="pageChanged(page)"
      data-testid="filter-integration">
      <option value="">Todas as integrações</option>
      <option *ngFor="let integration of integrations" [value]="integration.id">
        {{ integration.platform?.name }} · {{ integration.name }}
      </option>
    </select>
  </div>
  <div class="field">
    <label for="list_id">Lista</label>
    <select name="list_id" id="list_id" class="form-select"
      [(ngModel)]="listId"
      (change)="pageChanged(page)"
      data-testid="filter-list">
      <option value="">Todas as listas</option>
      <option *ngFor="let list of lists" [value]="list.id">
        {{ list.name }}
      </option>
    </select>
  </div>
  <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm clear" *ngIf="hasFilters" (click)="clearFilters()" data-testid="btn-clear-filters">
    <i class="fa fa-times"></i> Limpar filtros
  </button>
</div>

<app-skeleton *ngIf="loading" variant="table-row" [count]="6" [columns]="4"
  label="Carregando as automações" data-testid="campaigns-loading"></app-skeleton>

<section class="sf-card empty" *ngIf="!loading && loadError" data-testid="campaigns-error">
  <i class="fa fa-exclamation-triangle"></i>
  <p>Não foi possível carregar as automações. Tente de novo.</p>
  <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="listPaginated()" data-testid="btn-retry-campaigns">
    <i class="fa fa-refresh"></i> Tentar de novo
  </button>
</section>

<div *ngIf="!loading && !loadError && result && result.data.length > 0; else notFound" class="campaign-list">
  <div
    data-testid="campaign-item"
    class="row-card"
    *ngFor="let campaign of result.data"
    [class.is-active]="campaign.active"
    [class.is-inactive]="!campaign.active"
  >
    <span class="row-avatar"><i class="fa fa-bolt"></i></span>
    <div class="info">
      <div class="name">
        <a [routerLink]="['/campaigns/edit', campaign.id]" class="name-link">{{ campaign.name }}</a>
        <span class="status-pill status-pill--sm" [class.status-pill--ok]="campaign.active" [class.status-pill--disabled]="!campaign.active">
          {{ campaign.active ? 'Ativa' : 'Inativa' }}
        </span>
      </div>
      <div class="meta-line">
        <span class="bind-chip bind-chip--list" *ngIf="listName(campaign)" data-testid="campaign-list-chip">
          <i class="fa fa-list-ul"></i> {{ listName(campaign) }}
        </span>
        <span class="meta-chip" *ngIf="campaign.sequences" data-testid="campaign-steps">
          <i class="fa fa-bolt"></i> {{ stepsCount(campaign) }} passo{{ stepsCount(campaign) === 1 ? '' : 's' }}
        </span>
        <span
          *ngIf="campaign.send_window_enabled"
          class="meta-chip"
          title="Janela de silêncio: sem envios das {{ campaign.send_window_start_hour }}h às {{ campaign.send_window_end_hour }}h"
          data-testid="campaign-send-window"
        >
          <i class="fa fa-moon-o"></i> Silêncio {{ campaign.send_window_start_hour }}h–{{ campaign.send_window_end_hour }}h
        </span>
      </div>
    </div>
    <div class="icon-group">
      <app-switcher
        look="v2"
        [checked]="campaign.active"
        (change)="toggleActive(campaign)"
        [ngbTooltip]="campaign.active ? 'Desativar' : 'Ativar'"
      ></app-switcher>
      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
        (click)="showCopy(campaign)"
        ngbTooltip="Duplicar"
        aria-label="Duplicar automação"
        data-testid="btn-duplicate-campaign"
      >
        <i class="fa fa-copy"></i>
      </button>
      <a
        class="sf-btn sf-btn--primary sf-btn--icon sf-btn--sm"
        [routerLink]="['/campaigns/edit', campaign.id]"
        ngbTooltip="Editar"
        aria-label="Editar automação"
        data-testid="btn-edit-campaign"
      >
        <i class="fa fa-pencil"></i>
      </a>
      <button
        type="button"
        class="sf-btn sf-btn--danger sf-btn--icon sf-btn--sm"
        (click)="confirmDelete(campaign)"
        ngbTooltip="Excluir"
        aria-label="Excluir automação"
        data-testid="btn-delete-campaign"
      >
        <i class="fa fa-trash"></i>
      </button>
    </div>
  </div>
</div>

<app-pagination
  *ngIf="!loading && !loadError && result"
  look="v2"
  [currentPage]="result.current_page"
  [itemsPerPage]="result.per_page"
  [totalItems]="result.total"
  (pageChanged)="pageChanged($event)"
></app-pagination>

<ng-template #notFound>
  <!-- `!loading` para o vazio não piscar antes da primeira resposta. -->
  <section class="sf-card empty" *ngIf="!loading && !loadError" data-testid="campaigns-empty">
    <i class="fa" [class.fa-search]="hasFilters" [class.fa-bolt]="!hasFilters"></i>
    <!-- Os filtros voltam sozinhos da última visita: com qualquer um ligado, é "encontrada". -->
    <p>Nenhuma automação {{ hasFilters ? "encontrada" : "cadastrada" }}!</p>
    <a *ngIf="!hasFilters" [routerLink]="['/campaigns/new']" class="sf-btn sf-btn--primary sf-btn--sm">
      <i class="fa fa-plus-circle"></i> Nova automação
    </a>
    <button *ngIf="hasFilters" type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="clearFilters()" data-testid="btn-empty-clear-filters">
      <i class="fa fa-times"></i> Limpar filtros
    </button>
  </section>
</ng-template>

<ng-template #modalCampaign let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="fa fa-copy"></i>
      Duplicar automação
      <span class="sub">{{ campaign.name }}</span>
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <p class="section-hint">A cópia leva todos os passos da sequência. Escolha a lista em que ela vai rodar.</p>
    <div class="field-grid field-grid--1">
      <div class="field">
        <label for="name">Nome da automação</label>
        <input
          type="text"
          name="name"
          id="name"
          class="form-control"
          [(ngModel)]="copyName"
          autofocus
        />
      </div>
      <div class="field">
        <label for="list">Lista</label>
        <select
          name="list"
          id="list"
          class="form-select"
          *ngIf="lists$ | async as lists"
          [(ngModel)]="copyListId"
          data-testid="select-first-campaign"
        >
          <option *ngFor="let list of lists" [value]="list.id">
            {{ list.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.close('NO')">
      Cancelar
    </button>
    <button type="button" class="sf-btn sf-btn--primary" (click)="copy(modal)" data-testid="btn-save-copy-campaign">
      <i class="fa fa-copy"></i> Duplicar
    </button>
  </div>
</ng-template>
